import { inject } from '@angular/core';
import { Column } from 'angular-slickgrid';
import { BaseCrudComponent, FieldMapperHelper, ICrudService } from '@zendra/shared';
import {
  GetGisRegisterInconsistenciesInputDto,
  GisRegisterInconsistenciesExcelDownloadDto,
  GisRegisterInconsistencyDto,
  GisRegisterInconsistencyPlanningOrchestratorService,
} from 'orchestrator';
import { map, Observable, throwError } from 'rxjs';

type GisRegisterInconsistencyRow = GisRegisterInconsistencyDto & { id: number };
type UnsupportedCrudDto = Record<string, never>;

export abstract class GisRegisterInconsistencyBase extends BaseCrudComponent<
  GisRegisterInconsistencyRow,
  UnsupportedCrudDto,
  UnsupportedCrudDto,
  GisRegisterInconsistenciesExcelDownloadDto
> {
  private readonly orchestratorService = inject(GisRegisterInconsistencyPlanningOrchestratorService);
  private cachedColumns: Column[] | null = null;

  protected abstract get caseFilter(): Partial<GetGisRegisterInconsistenciesInputDto>;

  get columns(): Column[] {
    this.cachedColumns ??= FieldMapperHelper.buildColumnsFromFields(
      this.fields,
      this.localizationService,
      this.injector,
    );
    return this.cachedColumns;
  }

  service: ICrudService<
    GisRegisterInconsistencyRow,
    UnsupportedCrudDto,
    UnsupportedCrudDto,
    GisRegisterInconsistenciesExcelDownloadDto
  > = {
    create: () => this.unsupportedCrudOperation('create'),
    update: () => this.unsupportedCrudOperation('update'),
    deleteByIds: () => this.unsupportedCrudOperation('delete'),
    getList: query =>
      this.orchestratorService.getList({ ...query, ...this.caseFilter } as GetGisRegisterInconsistenciesInputDto).pipe(
        map(response => ({
          items: (response.items ?? []).map((item, index) => ({
            ...item,
            id: (query?.skipCount ?? 0) + index + 1,
          })),
          totalCount: response.totalCount ?? 0,
        })),
      ),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile({ ...input, ...this.caseFilter }),
  };

  protected prepareUpdateDto(): UnsupportedCrudDto {
    return {};
  }

  private unsupportedCrudOperation<T>(operation: string): Observable<T> {
    return throwError(() => new Error(`GIS register inconsistencies are read-only; ${operation} is not supported.`));
  }
}
